import { Injectable } from '@angular/core';

import { TimepickerModel } from './timepicker.interface';

export function TIMEPICKER_MODEL_ADAPTER_FACTORY() {
  return new DefaultTimepickerModelAdapter();
}

@Injectable({ providedIn: 'root', useFactory: TIMEPICKER_MODEL_ADAPTER_FACTORY })
export abstract class TimepickerModelAdapter<T> {
  /**
   * Converts a user-model time of type `T` to an `TimepickerModel` for internal use.
   */
  abstract fromModel(value: T | null): TimepickerModel | null;

  /**
   * Converts an internal `TimepickerModel` time to a user-model time of type `T`.
   */
  abstract toModel(time: TimepickerModel | null): T | null;
}

/**
 * This is default timepicker adapter handles how the time is represented in code i.e. ngModel.
 */

@Injectable()
export class DefaultTimepickerModelAdapter extends TimepickerModelAdapter<
  TimepickerModel
> {
  fromModel(value: TimepickerModel | null): TimepickerModel | null {
    if (value && !isNaN(value.hours) && !isNaN(value.minutes)) {
      return {
        hours: value.hours,
        minutes: value.minutes,
      };
    }
    return null;
  }

  toModel(value: TimepickerModel | null): TimepickerModel | null {
    if (value && !isNaN(value.hours) && !isNaN(value.minutes)) {
      return {
        hours: value.hours,
        minutes: value.minutes,
      };
    }
    return null;
  }
}
